const hero = {
    getlist: 'hero/getlist-by-admin',
    get: 'hero/get-by-admin',
    update: 'hero/update-by-admin',
    heroStatus: 'hero/set-status',
    remove: 'hero/remove',
    addGalleryHero: 'herogallery/add-by-admin',
    heroGalleryStatus: 'herogallery/set-status',
    removeHeroGallery: 'herogallery/remove-by-admin',
    updateHeroBlog: 'hero/update-blog',
    updateHeroStatus: 'hero/set-status',
    addToHero: 'hero/active-user',
}
export default hero